import { West } from "@mui/icons-material"
import { Avatar, Button, Stack, Tab, Tabs } from "@mui/material"
import React, { useEffect, useState } from "react"
import { Link, useParams, useSearchParams } from "react-router-dom"

import { BlueprintMetadata } from "./BlueprintMetadata"
import { BlueprintSourceCode } from "./BlueprintSourceCode"
import { BlueprintUserInterface } from "./BlueprintUserInterface"
import { AgentBlueprint, getAgentBlueprintById } from "../../api/blueprints-api"
import { LoadingSkeletons } from "../../components/LoadingSkeletons"
import { Subheading } from "../../components/Subheading"

type ActiveTab = "ui" | "source" | "metadata"

export function AgentBlueprintPage() {
  const { blueprintId } = useParams()
  const [blueprint, setBlueprint] = useState<AgentBlueprint>()
  const [loading, setLoading] = useState(true)

  const [searchParams, setSearchParams] = useSearchParams()
  const tab = searchParams.get("tab")

  const [activeTab, setActiveTab] = useState<ActiveTab>((tab as ActiveTab) || "ui")
  const handleChange = (event: React.SyntheticEvent, newValue: ActiveTab) => {
    setActiveTab(newValue)
    if (newValue === "ui") {
      setSearchParams({})
    } else {
      setSearchParams({ tab: newValue })
    }
  }

  useEffect(() => {
    if (!blueprintId) return

    setLoading(true)
    getAgentBlueprintById(blueprintId)
      .then(setBlueprint)
      .finally(() => setLoading(false))
  }, [blueprintId])

  if (loading) return <LoadingSkeletons />

  if (!blueprintId || !blueprint) return <Subheading>Not found</Subheading>

  return (
    <>
      <Button
        sx={{ paddingX: 2, marginX: 1, textTransform: "none" }}
        startIcon={<West />}
        size="small"
        component={Link}
        to="/?tab=agent-blueprints"
      >
        Back
      </Button>
      <Subheading sx={{ margin: 3 }}>
        <Stack direction="row" gap={2} alignItems="center">
          <Avatar
            src={`https://arweave.net/${blueprint.logo}`}
            alt={blueprint.name}
            sx={{ width: 32, height: 32 }}
          />
          <span>{blueprint.name}</span>
        </Stack>
      </Subheading>
      <Tabs value={activeTab} onChange={handleChange}>
        <Tab value="ui" label="User interface" />
        <Tab value="source" label="Source code" />
        <Tab value="metadata" label="Metadata" />
      </Tabs>
      {activeTab === "ui" && <BlueprintUserInterface />}
      {activeTab === "source" && <BlueprintSourceCode />}
      {activeTab === "metadata" && <BlueprintMetadata blueprint={blueprint} />}
    </>
  )
}
